import {Button, Dropdown, Empty, Skeleton} from "antd";
import type {MenuProps} from "antd";
import {DepartmentsListProps, CorrectDepartmentItem} from "../../../../../types/department";
import React, {FC} from "react";
import "./style.less"
import {Link} from "react-router-dom";
import {getImageLink} from "../../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../../enums/buckets"
import {DeleteOutlined, EditOutlined, MedicineBoxOutlined, MoreOutlined, RightOutlined} from "@ant-design/icons";
import {useAuth} from "../../../../../context/authContext";

const DepartmentsList: FC<DepartmentsListProps> = ({departmentsList, confirmDeleteDepartment, editButtonHandler, isLoading}) => {
  const {canManageContent} = useAuth()

  const getAdminMenu = (department: CorrectDepartmentItem): MenuProps["items"] => [
    {
      key: "edit",
      icon: <EditOutlined/>,
      label: "Редагувати",
      onClick: () => editButtonHandler(department),
    },
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined/>,
      label: "Видалити",
      onClick: () => confirmDeleteDepartment({
        departmentId: department.$id || "",
        departmentName: department.name,
      }),
    },
  ]

  return <section className="departments-section" aria-labelledby="departments-heading">
    <header className="departments-section__intro">
      <div className="departments-section__icon" aria-hidden="true"><MedicineBoxOutlined/></div>
      <div>
        <div className="departments-section__eyebrow">Медична допомога</div>
        <h1 className="departments-section__title" id="departments-heading">Наші відділення</h1>
        <p className="departments-section__description">
          Дізнайтеся більше про напрямки роботи лікарні, фахівців і доступні медичні послуги.
        </p>
      </div>
    </header>

    {isLoading && departmentsList.length === 0
      ? <div className="departments-grid departments-grid--loading" aria-label="Завантаження відділень">
        {[0, 1, 2, 3].map((item) => <div className="department-skeleton" key={item}>
          <Skeleton.Image active/>
          <Skeleton active paragraph={{rows: 1}} title={{width: "78%"}}/>
        </div>)}
      </div>
      : departmentsList.length === 0
        ? <div className="departments-section__empty"><Empty description="Відділення ще не додано"/></div>
        : <div className={`departments-grid ${isLoading ? "departments-grid--updating" : ""}`}>
          {departmentsList.map((department) => <article className="department-card" key={department.$id || department.name}>
            <Link className="department-card__link" to={`/department/${department.$id}`}
                  aria-label={`Відкрити відділення: ${department.name}`}>
              <div className="department-card__media">
                {department.previewImage
                  ? <img
                    className="department-card__image"
                    alt=""
                    src={getImageLink({imageId: department.previewImage, bucketId: BUCKETS.MAIN})}
                    loading="lazy"
                  />
                  : <div className="department-card__placeholder" aria-hidden="true"><MedicineBoxOutlined/></div>}
                <div className="department-card__overlay"/>
              </div>
              <div className="department-card__content">
                <h2 className="department-card__name">{department.name}</h2>
                <span className="department-card__more">Детальніше <RightOutlined/></span>
              </div>
            </Link>

            {canManageContent && <Dropdown menu={{items: getAdminMenu(department)}} trigger={["click"]}>
              <Button className="department-card__admin" type="text" shape="circle" icon={<MoreOutlined/>}
                      aria-label={`Керування відділенням: ${department.name}`}/>
            </Dropdown>}
          </article>)}
        </div>}
  </section>
}

export default DepartmentsList
